import { CurrencySelector } from "./currencySelector";
import { DonationForm } from "../donation/donationForm";
import { PledgeRadio } from "./pledgeRadio";
import { OtherAmountInput } from "./otherAmountInput";
import { onAmountChange, onCurrencySelected, updatePledgeAmounts, afterAmountUpdate } from "./donationAmountHelper";
import { StripePaymentElement } from "../stripe/stripePaymentElement";
import { translateText } from "../internationalization";

export class PledgeRadioWithCurrencyComponent {
    donationForm;
    currencySelector;
    handleOtherAmount;
    handles;
    paymentElement;
    currencyCode;
  
    constructor(donationForm, { currencySelectorEl,
      handleOtherAmountEl,
      pledgeRadioEl}, currencyCode = "USD", paymentElement = null) {
        this.donationForm = donationForm instanceof DonationForm ? donationForm : null; 
        this.donationForm.donationType = 'pledge';
        this.paymentElement = paymentElement instanceof StripePaymentElement ? paymentElement : null;
        this.currencySelector = currencySelectorEl? new CurrencySelector(currencySelectorEl, this.donationForm?.defaultCurrency): undefined;
        this.handleOtherAmount = handleOtherAmountEl? new OtherAmountInput(handleOtherAmountEl, this.currencySelector?.selectCurrency) : undefined;
        this.handles = new PledgeRadio(this.donationForm, this.handleOtherAmount, pledgeRadioEl, currencyCode);
        this.currencyCode = currencyCode;
    
        this.createCallbacks();
    }
    createCallbacks() {
      this.donationForm.saveFormInStorage("currency_code", this.currencySelector?.defaultCurrency?? "USD");
      this.createHandlesCallbacks();
      if (this.currencySelector) {
        this.createCurrencyCallbacks();
      }
    }
  
    createHandlesCallbacks() {
      this.handles.onAmountSelected = (value, usdValue) => {
        onAmountChange(value, usdValue, this.donationForm, this.paymentElement); 
        afterAmountUpdate(this.donationForm); 
      }
      if (this.handleOtherAmount) this.handleOtherAmount.onOtherAmountUpdate = (value, usdValue) =>  {
        onAmountChange(value, usdValue, this.donationForm, this.paymentElement); 
        afterAmountUpdate(this.donationForm); 
      }
    }
    createCurrencyCallbacks() {
      let otherAmountText = translateText("give.fields.other_amount", this.donationForm.translations);
      this.currencySelector.onValueSelected = (defaultCurrency) => onCurrencySelected(defaultCurrency, this.donationForm);
  
      this.currencySelector.onChange = (selectedIndex, selectedValue) => {
        const currentValue = this.donationForm.getStorage().currency_code;
        onCurrencySelected(selectedValue, this.donationForm);
        updatePledgeAmounts(currentValue, selectedValue, this.handles, this.donationForm, otherAmountText, this.paymentElement)
          .catch((er) => {
            this.currencySelector.selectCurrency.value = currentValue;
            onCurrencySelected(currentValue, this.donationForm);
            console.error(er);
          });
      };
    }
  }